export default class Search {
    constructor() {
        this._items = Array.from(document.querySelectorAll('input[type="search"]'));
    }
    render() {
        if (this._items.length) {
            this._items.forEach((item) => {
                item.addEventListener('keypress', (e) => {
                    if (e.keyCode === 13) {
                        e.preventDefault();
                        e.currentTarget.parentNode.submit();
                    }
                });
            });
        }
    }
}
